import styled from 'styled-components';
import theme from '../../../common/theme';

const ContactFormStyles = styled.div`
  margin: 40px auto 0 auto;
  width: 600px;
  .btn {
    background: ${theme.color.action};
    border: none;
    border-radius: 4px;
    color: #fff;
    font-size: 1em;
    padding: 15px 20px;
    float: right;
    cursor: pointer;
    &:hover {
      background: ${theme.color.actionHover};
    }
  }
  h2 {
    margin-bottom: 10px;
  }
  div {
    margin-top: 10px;
  }
  @media (max-width: 990px) {
    width: 100%;
    margin: 0;
  }
  .flash {
    padding: 10px;
    border-radius: 5px;
    border: solid 1px #0000CC;
    color: #0000CC;
  }
  .flash.error {
    border-color: red;
    color: red;
  }
`;

export default ContactFormStyles;



// WEBPACK FOOTER //
// ./src/hub_spot_form/components/contact_form/contact_form_styles.js